import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import Box, { Item as BoxItem } from 'devextreme-react/box';

import AntToolbar from './AntToolbar';
import WidgetItem from './AntWidgetStatisticGroupItem';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default forwardRef(function (props, ref) {
    const [formData, setFormData] = useState({});
    const [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url));

    // const imgIcon; // = props.session && props.session.app && props.session.appAssets ? props.session.app.assets.icons.icon_sale : null;

    const load = useCallback(async () => {
        if (props.url) {
            props.API.post(props.url, { ...props.searchConditions }, (data) => {
                if (data && data.error) setFormData({});
                else if (data && data.data) setFormData(data.data);
                else setFormData({});
                markLoaded();
            });
        }
    }, [props.API, props.url, props.searchConditions, setFormData, markLoaded]);

    useEffect(() => {
        load();

        var ms = ((props.refreshIntervalSec ?? 60) | 0) * 1000;
        if (ms <= 0) return;
        const interval = setInterval(() => {
            load();
        }, ms);

        return () => clearInterval(interval);
    }, [load, props.refreshIntervalSec]);

    useEffect(() => {
        load();
    }, [props.searchConditions, props.url, props.shouldRender]);

    useEffect(() => {
        if (props.dataSource && !props.url) setFormData(props.dataSource);
    }, [props.dataSource]);

    let clsNames = ['ant-statistic-group'];
    if (props.title) clsNames.push('ant-statistic-group-with-title');
    
    return (
        <React.Fragment>
            {props.title && (
                <AntToolbar
                    session={props.session}
                    title={props.title}
                    showHelp={props.showHelp}
                    isH6={true}
                    upperCase={true}
                    // upperCase={props.upperCase}
                />
            )}
            {!loaded && <AntWidgetSkeleton variant="stat" count={props.items ? props.items.length : 4} />}
            {loaded && (
            <div className={clsNames.join(' ')}>
                <Box direction="row" width="100%">
                    {props.items.map((item, index) => {
                        let value = formData[item.dataField];
                        if (value === undefined) value = 0;
                        return (
                            <BoxItem key={props.API.entityName + '-' + Math.floor(Math.random() * 100) + '-' + index} ratio={item.colspan}>
                                <WidgetItem
                                    // icon={imgIcon}
                                    value={value}
                                    dataType={item.dataType}
                                    caption={item.caption}
                                />
                            </BoxItem>
                        );
                    })}
                </Box>
            </div>
            )}
        </React.Fragment>
    );
});
